module.exports = __webpack_public_path__ + "static/media/eye.5e593957.svg";